<script module lang="ts">
  import type { Snippet } from 'svelte';
  import type { Optional } from '../../../types';
  import type { Props } from '@zag-js/combobox';
  import type { Styles } from '../../../../../panda/css';

  export interface ComboboxItem {
    label: string;
    value: string;
  }

  export interface ComboboxRootProps extends Optional<Omit<Props, 'dir' | 'getRootNode' | 'collection'>, 'id'> {
    children?: Snippet;
    items: ComboboxItem[];
    onValueChange?: (details: any) => void;
    placeholder?: string;
    positionerStyles?: Styles;
    inputStyles?: Styles;
    triggerStyles?: Styles;
    controlStyles?: Styles;
    clearOnOpen?: boolean;
  }
</script>

<script lang="ts">
  import { ComboboxProvider } from '../use-combobox-context';
  import { useCombobox } from '../use-combobox.svelte';
  import { comboboxStyles } from '../combobox.styles';
  import ComboboxInput from './combobox-input.svelte';
  import ComboboxContent from './combobox-content.svelte';

  const { children, items, placeholder, positionerStyles, inputStyles, triggerStyles, controlStyles, clearOnOpen, ...props }: ComboboxRootProps = $props();

  const id = $props.id();

  const combobox = useCombobox(items, { ...props, id, clearOnOpen });
  ComboboxProvider(combobox);

  export const clearAll = () => combobox.api.clearValue();
  export const setValue = (value: string[]) => combobox.api.setValue(value);

  const classes = comboboxStyles();
</script>

<div {...combobox.api.getRootProps()} class={classes.root}>
  <ComboboxInput placeholder={placeholder} inputStyles={inputStyles} triggerStyles={triggerStyles} controlStyles={controlStyles} />
  <ComboboxContent positionerStyles={positionerStyles} />
</div>

